// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import PropertyPage from '../../components/Property/PropertySearches';

type Props = {
    isAuthenticated?: boolean
    bondsAllowed?: boolean,
    individualAssetsAllowed?: boolean
};

const PropertySearches: React.FC<Props> = ({
    isAuthenticated,
    bondsAllowed,
    individualAssetsAllowed
}) => {
    return (
        <Entrypoint>
            <PropertyPage isAuthenticated={isAuthenticated ?? false} bondsAllowed={bondsAllowed ?? false} individualAssetsAllowed={individualAssetsAllowed ?? false} />
        </Entrypoint>
    );
}

export default PropertySearches;